import { Auth as AmplifyAuth } from "@aws-amplify/auth";
import { getSimulatedAuth } from "./mock-cypress-auth-provider";
import { simulatedAuth } from "./mode";

export const Auth = simulatedAuth ? getSimulatedAuth() : AmplifyAuth;
